import { Map } from "schemas/functions";
import { routes } from "schemas/routes";

export function getOnboardingPage(currentPathname: string) {
  if (currentPathname.endsWith(routes.aboutOnboarding)) {
    return "aboutForm";
  } else if (currentPathname.endsWith(routes.categoryOnboarding)) {
    return "categoryForm";
  }
}

export function onboardingNavigate(
  currentPathname: string,
  onboardingForm: Map,
  direction: "next" | "back",
) {
  if (currentPathname.endsWith(routes.aboutOnboarding)) {
    if (direction === "back") {
      return routes.preferencesOnboarding;
    } else if (direction === "next") {
      return routes.categoryOnboarding;
    }
  } else if (currentPathname.endsWith(routes.categoryOnboarding)) {
    if (direction === "back") {
      return routes.aboutOnboarding;
    } else {
      return routes.home;
    }
  } else {
    return routes.home;
  }
}
